import { BottomSheetModal } from '@gorhom/bottom-sheet';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import Button from 'shared/components/vxl/Button/Button';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleSmText from 'shared/components/vxl/typography/primary/title/TitleSmText';
import theme from 'shared/styles/theme';

interface PayOverTimeApplyNowBottomSheetProps {
  ref: React.Ref<BottomSheetModal>;
  onViewPaymentPlan: () => void;
  onIsOpenChange: (isOpen: boolean) => void;
  fetchingSubmitStatus: boolean;
}

const PayOverTimeApplyNowBottomSheet = ({
  ref,
  onViewPaymentPlan,
  onIsOpenChange,
  fetchingSubmitStatus,
}: PayOverTimeApplyNowBottomSheetProps) => {
  const { t } = useTranslation('payOverTime', {
    keyPrefix: 'applyNowBottomSheet',
  });

  const handleClose = useCallback(() => {
    if (ref && 'current' in ref) {
      ref.current?.dismiss();
    }
  }, [ref]);

  return (
    <BottomSheet
      ref={ref}
      analyticsId="/accounts/transaction-details/payOverTimeApplyNowBottomSheetViewed"
      setIsBottomSheetOpened={onIsOpenChange}
    >
      <View style={styles.container}>
        <TitleSmText style={styles.title} numberOfLines={0}>
          {t('title')}
        </TitleSmText>
        <BodyBaseText style={styles.body} numberOfLines={0}>
          {t('body')}
        </BodyBaseText>
        <View style={styles.buttonContainer}>
          <Button
            label={t('viewPaymentPlan')}
            type="PRIMARY"
            onPress={onViewPaymentPlan}
            analyticsId="payOverTimeViewPaymentPlanTapped"
            isDisabled={fetchingSubmitStatus}
            isLoading={fetchingSubmitStatus}
          />
          <Button
            label={t('close')}
            type="SECONDARY"
            onPress={handleClose}
            analyticsId="payOverTimeApplyNowBottomSheetCloseTapped"
          />
        </View>
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  body: {
    marginBottom: theme.spacing.xl,
  },
  buttonContainer: {
    gap: theme.spacing.m,
  },
  container: {
    paddingHorizontal: theme.spacing.m,
    marginBottom: theme.spacing.m,
  },
  title: {
    marginBottom: theme.spacing.s,
  },
});

export default PayOverTimeApplyNowBottomSheet;
